// First import on purpose: Sentry must be initialised before any other module is evaluated.
import './sentry'
import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import './index.css'
// Imported here so i18n is initialised before anything renders: the crash fallback needs
// translations even when the component that used to pull them in is what crashed.
import './translations'
import App from './App'
import { CrashFallback } from './components/CrashFallback'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './redux/store'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Sentry.ErrorBoundary fallback={({ eventId }) => <CrashFallback eventId={eventId} />}>
        <App />
      </Sentry.ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
